import React, { Suspense, lazy } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Anchor } from 'lucide-react';

// Lazy load Spline component
const Spline = lazy(() => import('@splinetool/react-spline'));

const Hero = ({ companyInfo, onContactClick }) => {
  if (!companyInfo) return null;

  // Stats section removed

  return (
    <section className="dark-container min-h-screen flex items-center">
      <div className="dark-content-container w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Maritime Consultancy Excellence section removed */}
            
            <h1 className="display-huge leading-tight" style={{color: 'var(--text-primary)'}}>
              {companyInfo.tagline}
            </h1>
            
            <p className="body-large text-text-secondary max-w-lg">
              {companyInfo.mission}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={onContactClick}
                className="btn-primary"
              >
                Start Your Journey
                <ArrowRight size={20} />
              </Button>
            </div>
            
            {/* Stats section removed */}
          </div>
          
          {/* Right Content - Spline 3D */}
          <div className="relative">
            <div className="w-full h-[700px] overflow-visible">
              <Suspense fallback={
                <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-100 to-cyan-100 rounded-lg">
                  <div className="text-center">
                    <div className="animate-spin w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
                    <p className="text-blue-600 font-medium">Loading 3D Experience...</p>
                  </div>
                </div>
              }>
                <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;